import { styled as t } from "@mui/joy";
import e from "@mui/joy/Card";
const o = t(e)(({ theme: t2 }) => ({ backgroundColor: t2.palette.isDarkMode ? t2.palette.neutral[200] : t2.palette.neutral[100] }));
export {
  o as BaseCard
};
//# sourceMappingURL=BaseCard.js.map
